/**
 * @copyright © Paramount Streaming
 * @author Stan Gletski
 * @description Adapted performance modes from player - matches avia-js exactly
 * @see {@link https://avia.cbsivideo.com/avia-js/latest/docs/api/player/enum/PerformanceMode}
 */
export enum PlayerAdapterPerformanceMode {
	AUTO = 'auto',
	DESKTOP = 'desktop',
	MOBILE = 'mobile',
	TV = 'tv',
	LOW = 'low'
}